import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { tryToGetItTabRapido } from 'app/entity/actions/entity.actions';
import { ResourceSharingOffer } from 'app/entity/models/rapido-offer';
import { isAuthorizedInKeycloak } from 'app/keycloak/reducers/keycloak.reducer';
import { State } from 'app/reducers';
import { RapidoOffersService } from 'app/services/rapido-offers.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-get-offers-button',
  templateUrl: './get-offers-button.component.html',
  styleUrls: ['./get-offers-button.component.scss'],
})
export class GetOffersButtonComponent implements OnInit, OnDestroy {
  @Input() public resourceId: string;
  @Input() public recordId: string;
  @Input() public tabName: string;
  @Input() public fgTitle: string;
  @Input() public isbn: string;
  public isPatronAuthorized: boolean;
  public offer: ResourceSharingOffer;
  public offerError: boolean = false;
  public loading: boolean = false;
  public supplyTimeInDays: number | null = null;
  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private readonly store: Store<State>,
    private readonly offersService: RapidoOffersService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.store.select(isAuthorizedInKeycloak).subscribe((isAuthorized) => {
        this.isPatronAuthorized = isAuthorized;
        if (this.isPatronAuthorized) {
          this.getOffers();
        }
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public getOffers() {
    this.loading = true;
    this.offerError = false;
    this.offersService.getOffers(this.recordId).subscribe((offers) => {
      if (offers.length) {
        this.offer = offers[0];
        this.supplyTimeInDays = this.convertSupplyTimeFromHoursToDays();
        this.offerError = false;
      } else {
        this.offer = null;
        this.offerError = true;
      }
      this.loading = false;
    });
  }

  public onGetIt(event: Event) {
    event.stopPropagation();
    this.store.dispatch(
      tryToGetItTabRapido({
        cardInfo: {
          title: this.fgTitle,
          id: this.resourceId,
          recordId: this.recordId,
          tabName: this.tabName,
          isbn: this.isbn,
        },
      })
    );
  }

  private convertSupplyTimeFromHoursToDays() {
    return this.offer && this.offer.supplyTime != null ? Math.ceil(this.offer.supplyTime / 24) :
                                                        this.offer.supplyTime;
  }
}
